// extracted by mini-css-extract-plugin
export default {"TextInput":"FilesSearchBox-module__TextInput--Rvr17","Box":"FilesSearchBox-module__Box--QJMeO"};